import { Navigate, Routes, Route } from "react-router-dom";
import Login from "../Views/Login/Login";
// import TrackStatusSingle from "../Views/TrackStatus/trackStatusSingle";
import Home from "../Views/Home/home";
// import RaiseRequestScreen from "../Views/RaiseRequest/_RaiseRequest";
import ContactUs from "../Views/ContactUs/ContactUs";
import Appointment from "../Views/Appointment/Appointment";
import CheckAppointment from "../Views/Appointment/CheckAppointment";

export default function NoAuthNav() {
  return (
    <>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
        {/* <Route path="/raise-request" element={<RaiseRequestScreen />} /> */}
        {/* <Route path="/track-status" element={<TrackStatusSingle />} /> */}
        <Route path="/appointment" element={<Appointment />} />
        <Route path="/check-appointment" element={<CheckAppointment />} />
        <Route path="/contact-us" element={<ContactUs />} />
        {/* <Route path="/track-order/:id" element={<TrackStatusSingle />} /> */}
        <Route path="*" element={<Navigate to={"/login"} />} />
      </Routes>
    </>
  );
}

// Check for bugs such as null pointer references, unhandled exceptions, and more.
